import React from 'react';
import Message, { MessageProps } from './Message';

import './style.scss';

const SystemMessage: React.FC<MessageProps> = (props) => {
  return (
    <div className="system-message"><Message {...props} /></div>
  );
};

export default SystemMessage;
